module.exports = __webpack_public_path__ + "img/Contact.bc181818.svg";